import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fillOpacity: ".3",
  d: "M17 4h-3V2h-4v2H7v7h10V4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 11v11h10V11H7z"
})), 'Battery60Sharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Battery60Sharp.js
// module id = 2261
// module chunks = 2